// Idea from http://afeld.github.io/bootstrap-toc/
// eslint-disable-next-line no-unused-vars
import $ from 'jquery'; // helpers

var findOrFilter = function findOrFilter($el, selector) {
  var $descendants = $el.find(selector);
  return $el.filter(selector).add($descendants).filter(':not([data-toc-skip])');
};

var generateUniqueIdBase = function generateUniqueIdBase(el) {
  var text = $(el).text();
  var anchor = text.trim().toLowerCase().replace(/[^A-Za-z0-9]+/g, '-');
  return anchor || el.tagName.toLowerCase();
};

var generateUniqueId = function generateUniqueId(el) {
  var anchorBase = generateUniqueIdBase(el); // eslint-disable-next-line no-plusplus

  for (var i = 0;; i++) {
    var anchor = anchorBase;

    if (i > 0) {
      // add suffix
      anchor += "-".concat(i);
    } // check if ID already exists


    if (!document.getElementById(anchor)) {
      return anchor;
    }
  }
};

var generateAnchor = function generateAnchor(el) {
  if (el.id) {
    return el.id;
  }

  var anchor = generateUniqueId(el);
  el.id = anchor;
  return anchor;
};

var createNavList = function createNavList() {
  return $('<ul class="nav flex-column"></ul>');
};

var createChildNavList = function createChildNavList($parent) {
  var $childList = createNavList();
  $parent.append($childList);
  return $childList;
};

var generateNavEl = function generateNavEl(anchor, text) {
  var $a = $('<a class="nav-link"></a>');
  $a.attr('href', "#".concat(anchor));
  $a.text(text);
  var $li = $('<li class="nav-item"></li>');
  $li.append($a);
  return $li;
};

var generateNavItem = function generateNavItem(headingEl) {
  var anchor = generateAnchor(headingEl);
  var $heading = $(headingEl);
  var text = $heading.data('toc-text') || $heading.text();
  return generateNavEl(anchor, text);
}; // Find the first heading level (`<h1>`, then `<h2>`, etc.) that
// has more than one element. Defaults to 1 (for `<h1>`).


var getTopLevel = function getTopLevel($scope) {
  // eslint-disable-next-line no-plusplus
  for (var i = 1; i <= 6; i++) {
    var $headings = findOrFilter($scope, "h".concat(i));

    if ($headings.length > 1) {
      return i;
    }
  }

  return 1;
}; // returns the elements for the top level, and the next below it


var getHeadings = function getHeadings($scope, topLevel) {
  var topSelector = "h".concat(topLevel);
  var secondaryLevel = topLevel + 1;
  var secondarySelector = "h".concat(secondaryLevel);
  return findOrFilter($scope, "".concat(topSelector, ",").concat(secondarySelector));
};

var getNavLevel = function getNavLevel(el) {
  return parseInt(el.tagName.charAt(1), 10);
};

var populateNav = function populateNav($topContext, topLevel, $headings) {
  var $context = $topContext;
  var $prevNav;
  $headings.each(function (i, el) {
    var $newNav = generateNavItem(el);
    var navLevel = getNavLevel(el); // determine the proper $context

    if (navLevel === topLevel) {
      // use top level
      $context = $topContext;
    } else if ($prevNav && $context === $topContext) {
      // create a new level of the tree and switch to it
      $context = createChildNavList($prevNav);
    } // else use the current $context


    $context.append($newNav);
    $prevNav = $newNav;
  });
};

var parseOps = function parseOps(arg) {
  var opts;

  if (arg.jquery) {
    opts = {
      $nav: arg
    };
  } else {
    opts = arg;
  }

  opts.$scope = opts.$scope || $(document.body);
  return opts;
}; // accepts a jQuery object, or an options
// import initNav from './toc';
// $('nav[data-toggle="toc"]').each((i, el) => {
//   var $nav = $(el);
//   init($nav);
// });


export default (function (opts) {
  opts = parseOps(opts); // ensure that the data attribute is in place for styling

  opts.$nav.attr('data-toggle', 'toc');
  var $topContext = createChildNavList(opts.$nav);
  var topLevel = getTopLevel(opts.$scope);
  var $headings = getHeadings(opts.$scope, topLevel);
  populateNav($topContext, topLevel, $headings);
});